export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },
  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },
  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blogs/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  },
  aiBlog: {
    blogList: "api/ai-blogs",
    blogCreate: "api/ai-blogs/store",
    blogEdit: "api/ai-blog/edit/",
    blogUpdate: "api/ai-blog/update/",
    blogDelete: "api/ai-blog/delete",
  },
  adminPress: {
    PressList: "api/press-release",
    PressCreate: "api/press-release/store",
    PressEdit: "api/press-release/edit/",
    PressUpdate: "api/press-release/update/",
    PressDelete: "api/press-release/delete",
  },
  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },
  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view",
  },



  serviceForm: {
    serviceCreate: "api/value-added-service/contact/store",
    serviceList: "api/value-added-service/contact/view",
  },


  jobApplication: {
    List: "api/job/applications",
    StatusUpdate:"api/application/status/update",
  },

  newsletter: {
    List: "api/newsletters",
  },
  career: {
    careerCreate: "api/career/store",
    careerList: "api/careers",
  },
  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },
  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },
  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },
  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },
  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },
  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },
  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },
  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },
  caseStudy: {
    caseStudyList: "api/casestudys",
    caseStudyCreate: "api/casestudys/store",
    caseStudyEdit: "api/casestudy/edit/",
    caseStudyUpdate: "api/casestudy/update/",
    caseStudyDelete: "api/casestudy/delete",
  },
  caseCategory: {
    caseCategoryList: "api/casestudy-categories",
    caseCategoryCreate: "api/casestudy-category/store",
    caseCategoryEdit: "api/casestudy-category/edit/",
    caseCategoryUpdate: "api/casestudy-category/update",
    caseCategoryDelete: "api/casestudy-category/delete",
  },
  news: {
    newsList: "api/medias",
    newsCreate: "api/media/store",
    newsEdit: "api/media/edit/",
    newsUpdate: "api/media/update/",
    newsDelete: "api/media/delete",
  },
  job: {
    List: "api/jobs",
    Create: "api/job/store",
    Edit: "api/job/edit/",
    Update: "api/job/update",
    Delete: "api/job/delete",
  },
  loc: {
    List: "api/locations",
    Create: "api/location/store",
    Edit: "api/location/edit/",
    Update: "api/location/update",
    Delete: "api/location/delete",
  },
  exp: {
    List: "api/experiences",
    Create: "api/experience/store",
    Edit: "api/experience/edit/",
    Update: "api/experience/update",
    Delete: "api/experience/delete",
  },
  operation: {
    List: "api/departments",
    Create: "api/department/store",
    Edit: "api/department/edit/",
    Update: "api/department/update",
    Delete: "api/department/delete",
  },
  locpage: {
    delete: "api/location-page/delete",
    List: "api/location-pages",
    Create: "api/location-page/store",
    Edit: "api/location-page/edit/",
    Update: "api/location-page/update",
  },

  Dashboard: {
    List: "api/leads-count",
     monthlycount: "api/leads-count-filter", 
  },
  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },
};
